import { Box, Divider, ListItem, Typography } from '@material-ui/core'
import { MenuOpen } from '@material-ui/icons'
import { useAppContext } from 'lib/hooks'
import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

export interface MenuLinkProps {
  path?: string
  text: string
  onClick?: () => void
  icon: string
  activeIcon: string
  external?: boolean
  disabled?: boolean
}

export const MenuLink = ({
  path,
  text,
  onClick,
  icon,
  disabled = false,
  external = false,
  activeIcon,
}: MenuLinkProps): JSX.Element => {
  const [showIcons, setShowIcons] = useState(true)
  const { isMobile } = useAppContext()

  const isActive = path === useLocation().pathname
  const color = 'white'

  useEffect(() => {
    function handleResize() {
      if (!isMobile) setShowIcons(window.innerHeight > 840)
    }

    window.addEventListener('resize', handleResize)
    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  let component = (
    <>
      <ListItem
        className={`sidebar-list-item ${isActive ? ` active ` : ``} `}
        disabled={disabled}
        onClick={onClick}
        button
        key={text}
        data-testid={path}
      >
        <Box
          sx={{ display: showIcons ? 'flex' : 'none' }}
          className="menu-icon justify-content-center"
        >
          {icon ? <i className={isActive ? activeIcon : icon} /> : <MenuOpen style={{ color }} />}
        </Box>
        <Box>
          <Typography
            className="sidebar-link"
            variant="caption"
            style={{
              fontWeight: isActive ? 600 : 400,
            }}
          >
            {text}
          </Typography>
        </Box>
      </ListItem>
      <Divider />
    </>
  )

  if (disabled) {
    return component
  }

  if (external) {
    component = (
      <a
        style={{
          color,
          textDecoration: 'none',
        }}
        key={path}
        href={path}
        target="_blank"
        rel="noreferrer"
      >
        {component}
      </a>
    )
  } else if (!(typeof onClick === 'function') && path) {
    component = (
      <Link
        key={path}
        style={{
          color,
          textDecoration: 'none',
        }}
        to={path}
      >
        {component}
      </Link>
    )
  }

  return component
}
